// shared/services/redirect.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class RedirectService {
  constructor(private http: HttpClient, private utils: UtilsService) {}

  getRedirectUrl(url: string): Observable<{ url: string; success: boolean; message?: string; statusCode?: string }> {
    const body = {
      email: environment.emailForRoutes,
      password: environment.passwordForRoutes,
      urlKey: url
    };
    const apiUrl = `https://${environment.apiDomain}${environment.pathForRoutes}`;
    return this.http
      .post<{ url: string; success: boolean; message?: string; statusCode?: string }>(
        apiUrl,
        body,
        { headers: this.utils.skipInterceptorHeaders }
      )
      .pipe(
        catchError((err) => {
          console.error('Redirect API error:', err);
          return of({
            url: '/error',
            success: false,
            message: 'Failed to fetch redirect URL',
            statusCode: '500'
          });
        })
      );
  }
}